const usersTypes = {

  get: {
    request: "GET_USER_REQUEST",
    success: "GET_USER_SUCCESS",
    failure: "GET_USER_FAILURE"
  },

  index: {
    request: "USERS_INDEX_REQUEST",
    success: "USERS_INDEX_SUCCESS",
    failure: "USERS_INDEX_FAILURE",
    select:  "USERS_INDEX_SELECT"
  },

  xlsx: {
    request: "USERS_XLSX_REQUEST",
    success: "USERS_XLSX_SUCCESS",
    failure: "USERS_XLSX_FAILURE"
  },

  create: {
    init:    "CREATE_USER_INIT",
    request: "CREATE_USER_REQUEST",
    success: "CREATE_USER_SUCCESS",
    failure: "CREATE_USER_FAILURE"
  },

  update: {
    request: "UPDATE_USER_REQUEST",
    success: "UPDATE_USER_SUCCESS",
    failure: "UPDATE_USER_FAILURE"
  },

  change_password: {
    request: "CHANGE_PASSWORD_REQUEST",
    success: "CHANGE_PASSWORD_SUCCESS",
    failure: "CHANGE_PASSWORD_FAILURE"
  },

  lock: {
    request: "ACCOUNT_OPERATION_REQUEST",
    success: "ACCOUNT_OPERATION_SUCCESS",
    single: "ACCOUNT_OPERATION_SINGLE_SUCCESS",
    failure: "ACCOUNT_OPERATION_FAILURE"
  },

  destroy: {
    request: "DESTROY_USER_REQUEST",
    success: "DESTROY_USER_SUCCESS",
    failure: "DESTROY_USER_FAILURE"
  },

  delete: {
    request: "DELETE_USER_REQUEST",
    success: "DELETE_USER_SUCCESS",
    failure: "DELETE_USER_FAILURE"
  },

  set_errors: "SET_USER_ERRORS",

  reset_user: "RESET_USER",

  clear_user: "CLEAR_USER"

}

export default usersTypes



// WEBPACK FOOTER //
// ./src/js/constants/usersTypes.js